import React, {ReactElement, useState} from 'react';
import HighlightedButtonElementComponent from '../button';
import HighlightedTextInputElementComponent from '../input/textInput';
import {ELEMENT} from '../../../../incase-domain/elements/base/ElementTypes';
import {IElement} from '../../../../incase-domain/elements';
import {ELEMENT_TABS} from '../../form/part/tabs';

interface HighlightedElementTypedProps {
    element: IElement;
    elementChangeHandler: {single: (field: keyof IElement | string, value: unknown) => void};
}

function HighlightedFormElementTyped(props: HighlightedElementTypedProps): ReactElement {
    const {element, elementChangeHandler} = props;

    const [activeTab] = useState((ELEMENT_TABS[element.type] && ELEMENT_TABS[element.type][0].id) || '');

    let highlighted;

    switch (element.type) {
        case ELEMENT.BUTTON:
            highlighted = (
                <HighlightedButtonElementComponent
                    activeTab={activeTab}
                    overrideHighlightedElement={element}
                    errors={null}
                    overrideHighlightedElementChangeHandler={elementChangeHandler}
                    inForm
                />
            );
            break;

        case ELEMENT.TEXT_INPUT:
            highlighted = (
                <HighlightedTextInputElementComponent
                    activeTab={activeTab}
                    overrideHighlightedElement={element}
                    errors={null}
                    overrideHighlightedElementChangeHandler={elementChangeHandler}
                    inForm
                />
            );

            break;
        default:
            highlighted = <div>Undefined element</div>;
    }

    return <>{highlighted}</>;
}

export default HighlightedFormElementTyped;
